// extracted by mini-css-extract-plugin
export default {"wrapper":"PageView_wrapper__ocKGI","pageRect":"PageView_pageRect__CMIkw","pageNo":"PageView_pageNo__mX7lw","bold":"PageView_bold__kha3y"};